import React, { useEffect, useRef, useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import IconButton from "@mui/material/IconButton";
import ReplyIcon from "@mui/icons-material/Reply";
import { useNavigate } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";
import apiClient from "../api/apiClient";
import { handleErrors } from "../modules/handleErrors";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from "react-toastify";
import StripeCheckoutModal from "../modals/StripeCheckoutModal";
import { getActiveSale, getSalePriceDisplay, formatPriceAmount } from "../utils/saleUtils";

// Sale discount applies to both listings and bundles (when product has sale data).
function getCartItemDisplayPrice(item) {
  const pd = item?.product_details;
  if (!pd) return { displayPrice: 0, hasDiscount: false, originalPrice: null };
  const saleInfo = getActiveSale(pd);
  const saleDisplay = getSalePriceDisplay(pd.price, saleInfo);
  const displayPrice = saleDisplay.displayDiscounted != null ? saleDisplay.displayDiscounted : parseFloat(pd.price || 0);
  return {
    displayPrice,
    hasDiscount: saleDisplay.hasDiscount,
    originalPrice: saleDisplay.hasDiscount ? saleDisplay.displayOriginal : null,
  };
}

const Cart = () => {
  const {
    profiledata,
    fetchDataprofile,
    cartItems,
    fetchcart,
    Loading,
    setCheckedItems,
    checkedItems,
  } = useIndexPageData();
  const navigate = useNavigate();
  const currentUrl = window.location.origin;
  const [totalPrice, setTotalPrice] = useState(0);
  const [showStripeModal, setShowStripeModal] = useState(0);
  const removingIdsRef = useRef(new Set());
  const [removingIds, setRemovingIds] = useState(() => new Set());

  const syncRemovingIds = () => {
    setRemovingIds(new Set(removingIdsRef.current));
  };

  const handleCheckboxChange = (product_id, productDetails) => {
    const modelType = productDetails.listings ? "bundle" : "listing";
    const item = { product_id, modelType };

    setCheckedItems((prevCheckedItems) => {
      const exists = prevCheckedItems.some(
        (checked) => checked.product_id === item.product_id
      );

      return exists
        ? prevCheckedItems.filter(
            (checked) =>
              !(
                checked.product_id === item.product_id &&
                checked.modelType === item.modelType
              )
          )
        : [...prevCheckedItems, item];
    });
  };

  const handlePayment = async () => {
    // if (checkedItems.length === 0)
    //   return toast.error("No items in your cart are selected.");

    try {
      //   const result = await apiClient.post("/checkout/", {
      //     items: checkedItems,
      //     url: currentUrl,
      //   });
      //   if (!result.ok) handleErrors(result.data);
      //   const paymentUrl = result?.data?.url;
      //   if (paymentUrl) {
      //     window.open(paymentUrl, "_blank");
      //   }

      //   await Promise.all(
      //     cartItems?.map(async (item) => {
      //       const result = await apiClient.delete(`/cartitems/${item?.id}/`);
      //       if (!result.ok) handleErrors(result?.data);
      //     })
      //   );
      //   await fetchcart();
      setShowStripeModal(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const removeItem = async (cartItemId, productId) => {
    if (removingIdsRef.current.has(cartItemId)) return;

    removingIdsRef.current.add(cartItemId);
    syncRemovingIds();

    try {
      const result = await apiClient.delete(`/cartitems/${cartItemId}/`);
      if (!result.ok) {
        handleErrors(result.data);
        return;
      }
      await fetchcart();
      setCheckedItems((prevCheckedItems) =>
        prevCheckedItems.filter((checked) => checked.product_id !== productId)
      );
    } catch (error) {
      console.error(error);
    } finally {
      removingIdsRef.current.delete(cartItemId);
      syncRemovingIds();
    }
  };

  useEffect(() => {
    const sum = cartItems
      .filter((item) =>
        checkedItems.some(
          (checked) => checked.product_id === item?.product_details?.id
        )
      )
      .reduce((acc, item) => acc + getCartItemDisplayPrice(item).displayPrice, 0);
    setTotalPrice(sum);
  }, [cartItems, checkedItems]);
  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="d-flex flex-md-nowrap flex-wrap align-items-center gap-3 mb-4 position-relative">
            <TbArrowBackUp
              style={{ fontSize: "32px", backgroundColor: "#F2F2F2" }}
              className="position-absolute back-arrow  me-2 rounded-5 p-1"
              onClick={() => navigate(-1)}
            />
            <div className="d-flex align-items-center gap-2">
              <ShoppingCartIcon sx={{ fontSize: "28px" }} />
              <h3>My Cart</h3>
            </div>
          </div>
          <div className="px-3">
            {cartItems.length === 0 && !Loading ? (
              <p className="text-center">Your cart is empty.</p>
            ) : (
              <ul className="px-0">
                {Loading ? (
                  <div className="d-flex justify-content-center mt-5">
                    <LoadingSpinner color="#FF3E1F" />
                  </div>
                ) : (
                  cartItems.map((item) => (
                    <li
                      key={item?.id}
                      className="d-flex gap-md-5 gap-3 flex-wrap flex-md-nowrap align-items-center p-3 rounded-3 mb-3"
                      style={{ backgroundColor: "#f2f2f2" }}
                    >
                      {/* <input
                        className="form-check-input mt-0"
                        type="checkbox"
                        checked={checkedItems.some(
                          (checked) =>
                            checked.product_id === item?.product_details?.id
                        )}
                        onChange={() =>
                          handleCheckboxChange(
                            item?.product_details?.id,
                            item?.product_details
                          )
                        }
                        aria-label="Checkbox for following text input"
                      /> */}
                      <div className="d-flex align-items-start justify-content-between w-full" >
                        <img
                          src={
                            item?.product_details?.file ||
                            item?.product_details?.bundle_thumbnails[0]?.image
                          }
                          className="card-img-top"
                          alt="Product"
                          style={{
                            width: "10rem",
                            height: "120px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderTopRightRadius: "30px",
                          }}
                        />
                              <RemoveCircleOutlineIcon
                          role="button"
                          aria-label="Remove from cart"
                          className="d-block d-md-none"
                          style={{
                            cursor: removingIds.has(item?.id)
                              ? "not-allowed"
                              : "pointer",
                            color: "red",
                            fontSize: "28px",
                            marginLeft: "auto",
                            opacity: removingIds.has(item?.id) ? 0.5 : 1,
                          }}
                          onClick={() =>
                            removeItem(item?.id, item?.product_details?.id)
                          }
                        />
                      </div>
                      <div className="d-flex flex-md-row flex-column gap-md-4 gap-2">
                        <div>
                          <h4>{item?.product_details?.title}</h4>
                          <p className="mb-hidden">
                            {item?.product_details?.short_description}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between gap-md-5 flex-column ms-auto">
                        <RemoveCircleOutlineIcon
                          role="button"
                          aria-label="Remove from cart"
                          className="d-none d-md-block"
                          style={{
                            cursor: removingIds.has(item?.id)
                              ? "not-allowed"
                              : "pointer",
                            color: "red",
                            fontSize: "28px",
                            marginLeft: "auto",
                            opacity: removingIds.has(item?.id) ? 0.5 : 1,
                          }}
                          onClick={() =>
                            removeItem(item?.id, item?.product_details?.id)
                          }
                        />
                        <div className=" d-flex align-items-center ">
                          {(() => {
                            const { displayPrice, hasDiscount, originalPrice } = getCartItemDisplayPrice(item);
                            return (
                              <p className="mb-0 d-flex align-items-center flex-wrap gap-1">
                                {hasDiscount && originalPrice != null && (
                                  <span className="text-muted text-decoration-line-through small">
                                    {formatPriceAmount(originalPrice)}
                                  </span>
                                )}
                                <span>{formatPriceAmount(displayPrice)}</span>
                              </p>
                            );
                          })()}
                        </div>
                      </div>
                    </li>
                  ))
                )}
              </ul>
            )}
            {cartItems.length > 0 && (
              <div className="">
                <div className="d-flex justify-content-end mt-4">
                  <h4>Total: {formatPriceAmount(totalPrice)}</h4>
                </div>
                <div className="text-end">
                  <button
                    className="btn red-btn rounded-3"
                    onClick={handlePayment}
                  >
                    Checkout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <StripeCheckoutModal
        open={showStripeModal}
        onClose={() => setShowStripeModal(false)}
        items={checkedItems}
        cartItems={cartItems}
        fetchcart={fetchcart}
        subtotal={totalPrice}
      />
    </>
  );
};

export default Cart;
